export const options= [
    {
        value: 1,
        name: "Very Poor",
    },
    {
        value: 2,
        name: "Poor",
    },
    {
        value: 3,
        name: "Average",
    },
    {
        value: 4,
        name: "Good",
    },
    {
        value: 5,
        name: "Awesome",
    },
]